<section class="centered-fullwidth grid grid-cols-1 py-9 desk:grid-cols-2 desk:gap-8 desk:pb-5 desk:pt-14">
  @let titleDescription = { title: data.title, description: data.description };
  <app-titre-description [data]="titleDescription" />
  @let itemsNb = data.items.length;
  <div
    [ngClass]="{ 'grid-cols-1': itemsNb === 1, 'grid-cols-2': itemsNb === 2 }"
    class="grid gap-x-1.5 px-5 desk:gap-x-3 desk:px-0">
    @let firstItem = data.items[0];
    @let secondItem = data.items[1];
    @if (firstItem) {
      <ng-container *ngTemplateOutlet="imageCtaTemplate; context: { item: firstItem }" />
    }
    @if (secondItem) {
      <ng-container *ngTemplateOutlet="imageCtaTemplate; context: { item: secondItem }" />
    }
  </div>
</section>
<ng-template #imageCtaTemplate let-item="item">
  <div class="flex flex-col gap-y-2 desk:gap-y-3">
    <!-- On desk, two items share the 524px column less a 12px gap. -->
    @let frameWidth = data.items.length === 2 ? 256 : 524;
    <app-image
      [image]="item.image"
      [isPriority]="!isImageInPreviousBlocks"
      [pregenerationSize]="{ width: frameWidth, height: 313, exact: 'desk' }"
      [size]="{ mh: 293, dh: 313 }"
      class="overflow-hidden rounded-2xl"></app-image>
    <app-button [isFullWidth]="true" [label]="item.cta.label" [url]="item.cta.url"></app-button>
  </div>
</ng-template>
